module.exports = __webpack_public_path__ + "img/299.7a954320.jpg";